import { h, Host } from '@stencil/core';
import cn from 'classnames';
import { ESectionHeaderColors } from '@pes-ui/utils';
export class SectionWithHeader {
  constructor() {
    this.headingLabel = undefined;
    this.withColumns = false;
    this.isInProductsFilters = false;
    this.color = ESectionHeaderColors.DEFAULT;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h(Host, { class: cn({ 'in-products-filters': this.isInProductsFilters }) }, h("section", { class: cn('section', {
        'section--with-columns': this.withColumns,
        'section--in-products-filters': this.isInProductsFilters,
      }) }, h("pes-section-header", { class: "section__heading", isInProductsFilters: this.isInProductsFilters }, h("qds-title", { class: "section__title", layer: "main", level: "subsection", alignment: "start" }, this.headingLabel)), h("div", { class: "section__content" }, h("slot", null)))));
  }
  static get is() { return "pes-section-with-header"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["section-with-header.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["section-with-header.css"]
    };
  }
  static get properties() {
    return {
      "headingLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "heading-label",
        "reflect": false
      },
      "withColumns": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "with-columns",
        "reflect": false,
        "defaultValue": "false"
      },
      "isInProductsFilters": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-in-products-filters",
        "reflect": false,
        "defaultValue": "false"
      },
      "color": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "SectionHeaderColors",
          "resolved": "ESectionHeaderColors.DEFAULT | ESectionHeaderColors.FUCHSIA | ESectionHeaderColors.INHERIT",
          "references": {
            "SectionHeaderColors": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines the header color. By default $se-life-green."
        },
        "attribute": "color",
        "reflect": false,
        "defaultValue": "ESectionHeaderColors.DEFAULT"
      }
    };
  }
  static get elementRef() { return "el"; }
}
